var _desc, _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcArrowDownDateFinder(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "14px",
    height: "7px",
    viewBox: "0 0 14 7",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icArrowDownDateFinder") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M131.032499,442.292041 C131.047158,442.30546 131.061218,442.31952 131.074637,442.334179 L136.055128,447.774998 C136.207984,447.941982 136.277955,448.157277 136.265041,448.368491 C136.278082,448.579697 136.208123,448.795233 136.055128,448.962368 L131.074637,454.403188 C130.822844,454.678252 130.395741,454.697118 130.120677,454.445326 L130.078538,454.403188 L130.078538,454.403188 C129.796642,454.095237 129.796642,453.622975 130.078538,453.315024 L134.605116,448.368876 L130.078538,443.422343 C129.796642,443.114392 129.796642,442.64213 130.078538,442.334179 C130.330331,442.059114 130.757434,442.040248 131.032499,442.292041 Z",
    id: "path-1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "DateFinder",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Datefinder----Confimartion",
    transform: "translate(-126.000000, -445.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "icArrowDownDateFinder",
    fill: "#333333",
    fillRule: "nonzero",
    transform: "translate(133.066833, 448.368683) rotate(90.000000) translate(-133.066833, -448.368683) ",
    xlinkHref: "#path-1"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcArrowDownDateFinder);
export default __webpack_public_path__ + "static/media/icArrowDownDateFinder.7a9229aaea07108fdb145d0f236e6364.svg";
export { ForwardRef as ReactComponent };